<div class="wrapper" id="fullscreenWrapper">
  <div class="close-button" (click)="closeImage()">
    <mat-icon>close</mat-icon>
  </div>
  <img [src]="transform(photo?.data?.url)" alt="" />
</div>
